module.exports = __webpack_public_path__ + "media/desktop.9c5573d4.webm";